import {
  FETCH_CAMPAIGN,
  FETCH_CAMPAIGN_SUCCESS,
  FETCH_CAMPAIGN_ERROR,
  ADD_CAMPAIGN,
  ADD_CAMPAIGN_SUCCESS,
  ADD_CAMPAIGN_ERROR,
  RESET_ADD_CAMPAIGN,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_ERROR,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_ERROR,
} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
  updating: false,
  deleting: false,
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_CAMPAIGN: {
      return {...state, error: '', loading: true};
    }
    case ADD_CAMPAIGN: {
      return {...state, error: '', updating: true};
    }
    case UPDATE_CAMPAIGN: {
      return {...state, error: '', updating: true};
    }
    case DELETE_CAMPAIGN: {
      return {...state, error: '', deleting: true};
    }
    case FETCH_CAMPAIGN_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case ADD_CAMPAIGN_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Thêm dữ liệu thành công!' }};
    }
    case UPDATE_CAMPAIGN_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }};
    }
    case DELETE_CAMPAIGN_SUCCESS: {
      const { id } = action.payload;
      const newData = state.data.filter(item => item.id !== id);
      return {...state, error: '', deleting: false, data: newData, payload: { code: 200, message: 'Xóa dữ liệu thành công!' }};
    }
    case FETCH_CAMPAIGN_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case ADD_CAMPAIGN_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case UPDATE_CAMPAIGN_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case DELETE_CAMPAIGN_ERROR: {
      return {...state, deleting: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_ADD_CAMPAIGN: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
